<!--
 * @Descripttion: 审批列表
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 16:35:29
-->
<template>
    <div class="house-system-container">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/index' }">
                            <i class="icon-home"></i> 首页
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>{{ taskName }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header>
            <div class="content-box">
                <el-scrollbar class="left-box overflow-x-hidden">
                    <el-tree
                        ref="newsTree"
                        :data="sourceTree"
                        :props="defaultProps"
                        :default-expand-all="false"
                        :highlight-current="true"
                        :expand-on-click-node="false"
                        :current-node-key="currentNodeKey"
                        node-key="id"
                        @node-click="handleNodeClick"
                        @node-expand="handleNodeExpand"
                    >
                        <span slot-scope="{ node, data }" class="custom-tree-node">
                            <span>{{ node.label }}</span>
                            <span :id="data.id" class="cnt">{{ data.count }}</span>
                        </span>
                    </el-tree>
                </el-scrollbar>
                <!-- 我的审批列表 -->
                <to-do-app
                    ref="toDoApp"
                    :title="taskName"
                    :visible="isApp"
                    :current-key="currentNodeKey"
                    @reload="queryDomAppNum"
                    @queryCount="setAppCount"
                    @check="handleCheck"
                />
                <!-- 已发起列表 -->
                <to-do-flow ref="toDoFlow" :title="taskName" :visible="isFlow" />
                <!-- 流程草稿列表 -->
                <to-do-draft ref="toDoDraft" :title="taskName" :visible="isDraft" />
                <!-- 批量补卡审批列表 -->
                <to-do-check ref="toDoCheck" :visible="isCheck" />
                <!--  历史流程列表 -->
                <to-do-history ref="toDoHistory" :title="taskName" :title1="title1" :visible="isHistory" />
            </div>
        </div>
    </div>
</template>
<script>
import ToDoApp from "./components/to-do-app";
import ToDoFlow from "./components/to-do-flow";
import ToDoDraft from "./components/to-do-draft";
import toDoCheck from "./components/to-do-check";
import toDoHistory from "./components/to-do-history";
import { APPROVE_KEYS as KEYS, TASK_MAP_KEYS } from "@/config/constants";
import { searchApprovalNum, getHistoryMinYear } from "@/api";

export default {
    name: "ApproveManage",
    components: {
        ToDoApp,
        ToDoFlow,
        ToDoDraft,
        toDoCheck,
        toDoHistory,
    },
    data() {
        return {
            sourceTree: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            currentNodeKey: "",
            taskName: "",
            isApp: true, // 审批(收藏列表)
            isFlow: false, // 我发起
            isDraft: false, // 流程草稿
            isCheck: false, // 批量补卡申请
            isHistory: false, // 历史流程
            title1: "",
        };
    },
    watch: {
        $route: {
            handler: function(to) {
                this.setCurrentTreeKey(to.query);
            },
            immediate: true,
        },
    },
    mounted() {
        this.setCurrentTreeKey(this.$route.query);
        this.tabListener();
    },
    methods: {
        loadData() {
            switch (this.currentNodeKey) {
                case KEYS.ALL:
                case KEYS.TODO_CHECK:
                case KEYS.TODO_READ:
                case KEYS.DONE_CHECK:
                case KEYS.DONE_READ:
                case KEYS.WORK_COMMUNICATE:
                    this.$refs.toDoApp.loadData();
                    break;
                case KEYS.HAS_APPLY:
                    this.$refs.toDoFlow.loadData();
                    break;
                case KEYS.DRAFT_PROCESS:
                    this.$refs.toDoDraft.loadData();
                    break;
                case KEYS.DONE_CHECK_PROCESS:
                    this.$refs.toDoHistory.loadData();
                    break;
                case KEYS.COLLECT_PROCESS:
                    this.$refs.toDoApp.loadData();
                    break;
                default:
                    break;
            }
            this.changeStatus();
        },
        initTreeCount(callback) {
            this.queryAppNum(callback);
        },
        setCurrentTreeKey(query) {
            this.initTreeCount(() => {
                if (Object.keys(query).length > 0) {
                    this.currentNodeKey = query.appType.toString();
                    this.taskName = TASK_MAP_KEYS.get(String(this.currentNodeKey));
                    const appType = parseInt(query.appType);
                    this.initAppSearch(appType);
                    this.changeStatus();
                    this.$nextTick(() => {
                        this.$refs.newsTree.setCurrentKey(this.currentNodeKey);
                        this.loadData();
                    });
                }
            });
        },
        changeStatus() {
            if (this.currentNodeKey === KEYS.HAS_APPLY) {
                //我的申请
                this.isApp = false;
                this.isFlow = true;
                this.isDraft = false;
                this.isCheck = false;
                this.isHistory = false;
            } else if (this.currentNodeKey === KEYS.DRAFT_PROCESS) {
                // 流程草稿
                this.isApp = false;
                this.isFlow = false;
                this.isDraft = true;
                this.isCheck = false;
                this.isHistory = false;
            } else if (this.currentNodeKey === KEYS.DONE_CHECK_PROCESS) {
                // 历史流程
                this.isApp = false;
                this.isFlow = false;
                this.isDraft = false;
                this.isCheck = false;
                this.isHistory = true;
            } else {
                // 我的审批（收藏列表）
                this.isApp = true;
                this.isFlow = false;
                this.isDraft = false;
                this.isCheck = false;
                this.isHistory = false;
            }
        },
        handleCheck() {
            this.isApp = false;
            this.isFlow = false;
            this.isDraft = false;
            this.isCheck = true;
            this.$refs.toDoCheck.loadData();
        },
        // 初始化审批搜索参数
        initAppSearch(appType) {
            appType = String(appType) || "";
            let taskType = 0,
                handleType = 0,
                handleGroup = "ALL",
                isCollect = null;

            if (appType === KEYS.ALL) {
                taskType = null;
                handleType = null;
                handleGroup = "ALL";
            }
            if (appType === KEYS.COLLECT_PROCESS) {
                isCollect = true;
                taskType = null;
                handleType = null;
                handleGroup = "ALL";
            }
            if ([KEYS.TODO_CHECK, KEYS.TODO_READ, KEYS.DONE_CHECK, KEYS.DONE_READ].includes(appType)) {
                taskType = 0;
                handleType = Number(appType);
                handleGroup = "ALL";
            }
            if (appType === KEYS.WORK_COMMUNICATE) {
                taskType = 1;
                handleType = 0;
                handleGroup = "ALL";
            }

            this.$refs.toDoApp.changeSearchOps({
                taskType,
                handleType,
                handleGroup,
                isCollect,
                showColumns: appType === "0" ? true : false,
            });
        },
        // 重置数量
        setAppCount(el, num, type) {
            // 待阅
            if (type === "todoRead") {
                const rCnt = document.getElementById("1");
                const sCnt = document.getElementById(el);
                rCnt.innerText = parseInt(parseInt(rCnt.innerText) - num);
                sCnt.innerText = parseInt(parseInt(sCnt.innerText) - num);
                return;
            }
            // 工作沟通-待审
            const rCnt = document.getElementById("5-2-ALL");
            const sCnt = document.getElementById(el);

            rCnt.innerText = parseInt(parseInt(rCnt.innerText) + num);
            sCnt.innerText = parseInt(parseInt(sCnt.innerText) - num);
        },
        tabListener() {
            document.addEventListener("visibilitychange", () => {
                if (document.visibilityState === "hidden") {
                    //切离该页面时执行
                } else if (document.visibilityState === "visible") {
                    //切换到该页面时执行
                    console.log("标签切换");
                    setTimeout(() => {
                        this.loadData();
                        this.queryDomAppNum();
                    }, 500);
                }
            });
        },
        // 查询审批数量
        async queryDomAppNum() {
            try {
                const { body, code, message } = await searchApprovalNum();
                if (code === "0000") {
                    const {
                        total,
                        doneCount,
                        readCount,
                        todoCount,
                        unreadCount,
                        collectCount,
                        communicateDoneCount,
                        communicateTodoCount,
                        normalTaskDoneGroupCount,
                        normalTaskReadGroupCount,
                        normalTaskTodoGroupCount,
                        normalTaskUnreadGroupCount,
                        communicateTaskDoneGroupCount,
                        communicateTaskTodoGroupCount,
                    } = body;
                    const workGroupCount = communicateDoneCount + communicateTodoCount;
                    // 全部
                    this.formatTreeCount(document.getElementById("-1"), total);
                    // 待审
                    this.formatTreeCount(document.getElementById("0"), todoCount);
                    this.formatTreeCount(document.getElementById("0-HXYW"), normalTaskTodoGroupCount.hxywCount);
                    this.formatTreeCount(document.getElementById("0-TYYW"), normalTaskTodoGroupCount.tyywCount);
                    this.formatTreeCount(document.getElementById("0-RSKQ"), normalTaskTodoGroupCount.rskqCount);
                    this.formatTreeCount(document.getElementById("0-FYBX"), normalTaskTodoGroupCount.fybxCount);
                    this.formatTreeCount(document.getElementById("0-GDDB"), normalTaskTodoGroupCount.gddbCount);
                    // 待阅
                    this.formatTreeCount(document.getElementById("1"), unreadCount);
                    this.formatTreeCount(document.getElementById("1-HXYW"), normalTaskUnreadGroupCount.hxywCount);
                    this.formatTreeCount(document.getElementById("1-TYYW"), normalTaskUnreadGroupCount.tyywCount);
                    this.formatTreeCount(document.getElementById("1-RSKQ"), normalTaskUnreadGroupCount.rskqCount);
                    this.formatTreeCount(document.getElementById("1-FYBX"), normalTaskUnreadGroupCount.fybxCount);
                    this.formatTreeCount(document.getElementById("1-GDDB"), normalTaskUnreadGroupCount.gddbCount);
                    // 已审
                    this.formatTreeCount(document.getElementById("2"), doneCount);
                    this.formatTreeCount(document.getElementById("2-HXYW"), normalTaskDoneGroupCount.hxywCount);
                    this.formatTreeCount(document.getElementById("2-TYYW"), normalTaskDoneGroupCount.tyywCount);
                    this.formatTreeCount(document.getElementById("2-RSKQ"), normalTaskDoneGroupCount.rskqCount);
                    this.formatTreeCount(document.getElementById("2-FYBX"), normalTaskDoneGroupCount.fybxCount);
                    this.formatTreeCount(document.getElementById("2-GDDB"), normalTaskDoneGroupCount.gddbCount);
                    // 已阅
                    this.formatTreeCount(document.getElementById("3"), readCount);
                    this.formatTreeCount(document.getElementById("3-HXYW"), normalTaskReadGroupCount.hxywCount);
                    this.formatTreeCount(document.getElementById("3-TYYW"), normalTaskReadGroupCount.tyywCount);
                    this.formatTreeCount(document.getElementById("3-RSKQ"), normalTaskReadGroupCount.rskqCount);
                    this.formatTreeCount(document.getElementById("3-FYBX"), normalTaskReadGroupCount.fybxCount);
                    this.formatTreeCount(document.getElementById("3-GDDB"), normalTaskReadGroupCount.gddbCount);
                    // 工作沟通
                    this.formatTreeCount(document.getElementById("5"), workGroupCount);
                    this.formatTreeCount(document.getElementById("5-0-ALL"), communicateTodoCount);
                    this.formatTreeCount(
                        document.getElementById("5-0-GZXT"),
                        communicateTaskTodoGroupCount.workCollaboration
                    );
                    this.formatTreeCount(document.getElementById("5-0-GZTZ"), communicateTaskTodoGroupCount.workNotice);
                    this.formatTreeCount(
                        document.getElementById("5-0-HDJL"),
                        communicateTaskTodoGroupCount.activityExchange
                    );
                    this.formatTreeCount(document.getElementById("5-2-ALL"), communicateDoneCount);
                    this.formatTreeCount(
                        document.getElementById("5-2-GZXT"),
                        communicateTaskDoneGroupCount.workCollaboration
                    );
                    this.formatTreeCount(document.getElementById("5-2-GZTZ"), communicateTaskDoneGroupCount.workNotice);
                    this.formatTreeCount(
                        document.getElementById("5-2-HDJL"),
                        communicateTaskDoneGroupCount.activityExchange
                    );
                    // 收藏流程
                    this.formatTreeCount(document.getElementById("9"), collectCount);
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },

        formatTreeCount(dom, count) {
            if (dom) {
                dom.innerText = count;
            }
        },
        // 查询审批数量
        async queryAppNum(callback) {
            try {
                const { body, code, message } = await searchApprovalNum();
                if (code === "0000") {
                    const {
                        total,
                        doneCount,
                        readCount,
                        todoCount,
                        unreadCount,
                        collectCount,
                        communicateDoneCount,
                        communicateTodoCount,
                        normalTaskDoneGroupCount,
                        normalTaskReadGroupCount,
                        normalTaskTodoGroupCount,
                        normalTaskUnreadGroupCount,
                        // communicateTaskDoneGroupCount,
                        // communicateTaskTodoGroupCount,
                    } = body;
                    const workGroupCount = communicateDoneCount + communicateTodoCount;
                    this.sourceTree = [
                        {
                            id: "-1",
                            label: "全部",
                            count: total,
                            children: [],
                        },
                        {
                            id: "0",
                            label: "待审",
                            showColumns: true,
                            count: todoCount,
                            children: [
                                {
                                    id: "0-HXYW",
                                    showColumns: true,
                                    label: "核心业务",
                                    count: normalTaskTodoGroupCount.hxywCount,
                                    children: [],
                                },
                                {
                                    id: "0-TYYW",
                                    label: "通用业务",
                                    showColumns: true,
                                    count: normalTaskTodoGroupCount.tyywCount,
                                    children: [],
                                },
                                {
                                    id: "0-RSKQ",
                                    label: "人事考勤",
                                    showColumns: true,
                                    count: normalTaskTodoGroupCount.rskqCount,
                                    children: [],
                                },
                                {
                                    id: "0-FYBX",
                                    label: "费用报销",
                                    showColumns: true,
                                    count: normalTaskTodoGroupCount.fybxCount,
                                    children: [],
                                },
                                {
                                    id: "0-GDDB",
                                    label: "工单督办",
                                    showColumns: true,
                                    count: normalTaskTodoGroupCount.gddbCount,
                                    children: [],
                                },
                            ],
                        },
                        {
                            id: "1",
                            label: "待阅",
                            count: unreadCount,
                            children: [
                                {
                                    id: "1-HXYW",
                                    label: "核心业务",
                                    count: normalTaskUnreadGroupCount.hxywCount,
                                    children: [],
                                },
                                {
                                    id: "1-TYYW",
                                    label: "通用业务",
                                    count: normalTaskUnreadGroupCount.tyywCount,
                                    children: [],
                                },
                                {
                                    id: "1-RSKQ",
                                    label: "人事考勤",
                                    count: normalTaskUnreadGroupCount.rskqCount,
                                    children: [],
                                },
                                {
                                    id: "1-FYBX",
                                    label: "费用报销",
                                    count: normalTaskUnreadGroupCount.fybxCount,
                                    children: [],
                                },
                                {
                                    id: "1-GDDB",
                                    label: "工单督办",
                                    count: normalTaskUnreadGroupCount.gddbCount,
                                    children: [],
                                },
                            ],
                        },
                        {
                            id: "2",
                            label: "已审",
                            showColumns: true,
                            count: doneCount,
                            children: [
                                {
                                    id: "2-HXYW",
                                    label: "核心业务",
                                    showColumns: true,
                                    count: normalTaskDoneGroupCount.hxywCount,
                                    children: [],
                                },
                                {
                                    id: "2-TYYW",
                                    label: "通用业务",
                                    showColumns: true,
                                    count: normalTaskDoneGroupCount.tyywCount,
                                    children: [],
                                },
                                {
                                    id: "2-RSKQ",
                                    label: "人事考勤",
                                    showColumns: true,
                                    count: normalTaskDoneGroupCount.rskqCount,
                                    children: [],
                                },
                                {
                                    id: "2-FYBX",
                                    label: "费用报销",
                                    showColumns: true,
                                    count: normalTaskDoneGroupCount.fybxCount,
                                    children: [],
                                },
                                {
                                    id: "2-GDDB",
                                    label: "工单督办",
                                    showColumns: true,
                                    count: normalTaskDoneGroupCount.gddbCount,
                                    children: [],
                                },
                            ],
                        },
                        {
                            id: "3",
                            label: "已阅",
                            count: readCount,
                            children: [
                                {
                                    id: "3-HXYW",
                                    label: "核心业务",
                                    count: normalTaskReadGroupCount.hxywCount,
                                    children: [],
                                },
                                {
                                    id: "3-TYYW",
                                    label: "通用业务",
                                    count: normalTaskReadGroupCount.tyywCount,
                                    children: [],
                                },
                                {
                                    id: "3-RSKQ",
                                    label: "人事考勤",
                                    count: normalTaskReadGroupCount.rskqCount,
                                    children: [],
                                },
                                {
                                    id: "3-FYBX",
                                    label: "费用报销",
                                    count: normalTaskReadGroupCount.fybxCount,
                                    children: [],
                                },
                                {
                                    id: "3-GDDB",
                                    label: "工单督办",
                                    count: normalTaskReadGroupCount.gddbCount,
                                    children: [],
                                },
                            ],
                        },
                        {
                            id: "5",
                            label: "工作沟通",
                            count: workGroupCount,
                            children: [
                                {
                                    id: "5-0-ALL",
                                    label: "待审",
                                    count: communicateTodoCount,
                                    children: [
                                        // {
                                        //     id: "5-0-GZXT",
                                        //     label: "工作协同",
                                        //     count: communicateTaskTodoGroupCount.workCollaboration,
                                        //     children: [],
                                        // },
                                        // {
                                        //     id: "5-0-GZTZ",
                                        //     label: "工作通知",
                                        //     count: communicateTaskTodoGroupCount.workNotice,
                                        //     children: [],
                                        // },
                                        // {
                                        //     id: "5-0-HDJL",
                                        //     label: "活动交流",
                                        //     count: communicateTaskTodoGroupCount.activityExchange,
                                        //     children: [],
                                        // },
                                    ],
                                },
                                {
                                    id: "5-2-ALL",
                                    label: "已审",
                                    count: communicateDoneCount,
                                    children: [
                                        // {
                                        //     id: "5-2-GZXT",
                                        //     label: "工作协同",
                                        //     count: communicateTaskDoneGroupCount.workCollaboration,
                                        //     children: [],
                                        // },
                                        // {
                                        //     id: "5-2-GZTZ",
                                        //     label: "工作通知",
                                        //     count: communicateTaskDoneGroupCount.workNotice,
                                        //     children: [],
                                        // },
                                        // {
                                        //     id: "5-2-HDJL",
                                        //     label: "活动交流",
                                        //     count: communicateTaskDoneGroupCount.activityExchange,
                                        //     children: [],
                                        // },
                                    ],
                                },
                            ],
                        },
                        {
                            id: "6",
                            label: "我发起",
                            count: "",
                            children: [],
                        },
                        {
                            id: "8",
                            // label: "已审批流程（一年内）",
                            label: "历史审批流程",
                            count: "",
                            children: [],
                        },
                        {
                            id: "7",
                            label: "流程草稿",
                            count: "",
                            children: [],
                        },
                        {
                            id: "9",
                            label: "收藏流程",
                            count: collectCount,
                            children: [],
                        },
                    ];
                    callback && callback();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
        clearKeywords() {
            this.$refs.toDoApp.clearKw();
            this.$refs.toDoFlow.clearKw();
            this.$refs.toDoDraft.clearKw();
            this.$refs.toDoCheck.clearKw();
            this.$refs.toDoHistory.clearKw();
        },
        // 节点展开回调
        handleNodeExpand() {
            setTimeout(() => {
                this.queryDomAppNum();
            }, 500);
        },
        // 点击节点回调
        handleNodeClick(data) {
            this.clearKeywords();
            let { showColumns } = data;
            if (!data.id.startsWith("-") && data.id.includes("-")) {
                const [tid, hid, gid] = data.id.split("-");
                if (tid === KEYS.WORK_COMMUNICATE) {
                    // 工作沟通
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 1,
                        handleType: parseInt(hid),
                        handleGroup: gid,
                    });
                } else {
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 0,
                        handleType: parseInt(tid),
                        handleGroup: hid,
                        showColumns,
                    });
                }
                this.taskName = TASK_MAP_KEYS.get(tid);
                this.currentNodeKey = tid;
            } else {
                if (data.id === KEYS.WORK_COMMUNICATE) {
                    // 工作沟通
                    this.$refs.toDoApp.changeSearchOps({
                        taskType: 1,
                        handleType: 0,
                        handleGroup: "ALL",
                    });
                } else if (data.id === KEYS.HAS_APPLY) {
                    // 我发起
                } else if (data.id === KEYS.DRAFT_PROCESS) {
                    // 流程草稿
                } else if (data.id === KEYS.DONE_CHECK_PROCESS) {
                    // 历史流程
                } else {
                    //-1-全部；0-待办；1-待阅；2-已审；3-已阅;4-已处理；9-收藏流程
                    if (data.id === KEYS.ALL) {
                        this.$refs.toDoApp.changeSearchOps({
                            taskType: null,
                            handleType: null,
                            handleGroup: "ALL",
                            isCollect: null,
                        });
                    } else if (data.id === KEYS.COLLECT_PROCESS) {
                        this.$refs.toDoApp.changeSearchOps({
                            taskType: null,
                            handleType: null,
                            handleGroup: "ALL",
                            isCollect: true,
                        });
                    } else {
                        this.$refs.toDoApp.changeSearchOps({
                            taskType: 0,
                            handleType: parseInt(data.id),
                            handleGroup: "ALL",
                            isCollect: null,
                            showColumns,
                        });
                    }
                }

                this.taskName = TASK_MAP_KEYS.get(data.id);
                this.currentNodeKey = data.id;
                if (this.taskName === "历史审批流程") {
                    this.getHistoryYear();
                } else {
                    this.title1 = "";
                }
            }

            this.$nextTick(() => {
                this.loadData();
            });
        },
        async getHistoryYear() {
            let res = await getHistoryMinYear();
            if (res.body) {
                this.title1 = `(从${res.body}至今)`;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
